var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.058 7.11A1.333 1.333 0 0 0 2 9.386h.114a1.1 1.1 0 0 1 1.006.667 1.1 1.1 0 0 1-.22 1.213l-.04.04a1.333 1.333 0 1 0 1.887 1.887l.04-.04A1.1 1.1 0 0 1 6 12.933a1.1 1.1 0 0 1 .72 1.007V14a1.333 1.333 0 0 0 2.667 0v-.114a1.1 1.1 0 0 1 .667-1.006 1.1 1.1 0 0 1 1.213.22l.04.04a1.335 1.335 0 1 0 1.887-1.887l-.04-.04a1.1 1.1 0 0 1-.22-1.214 1.1 1.1 0 0 1 1.006-.666H14a1.333 1.333 0 0 0 .943-2.276M4.667 6l3.334 3.333m0 0L11.334 6M8.001 9.333v-8",
    stroke: "{stroke}",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearExport);
export default __webpack_public_path__ + "static/media/gearExport.5b9962ae4e3438f35e0ed3bf2872a617.svg";
export { ForwardRef as ReactComponent };